<template>
  <li class="select-none">
    <!-- Nodo categoría -->
    <div
      class="flex items-center gap-0.5 px-1 py-0.5 rounded hover:bg-gray-100 dark:hover:bg-gray-700/50 group"
      :style="{ paddingLeft: `${(nivel * 12) + 4}px` }"
    >
      <!-- Toggle expand -->
      <button
        @click="expandido = !expandido"
        class="w-3.5 h-3.5 flex items-center justify-center text-gray-400 flex-shrink-0"
        :class="tieneHijos ? 'cursor-pointer hover:text-gray-600' : 'cursor-default'"
      >
        <svg v-if="tieneHijos" class="w-2.5 h-2.5 transition-transform duration-150" :class="expandido ? 'rotate-90' : ''" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
        </svg>
        <span v-else class="w-2.5 h-2.5 inline-block"></span>
      </button>

      <!-- Icono carpeta -->
      <span class="text-xs flex-shrink-0">📁</span>

      <!-- Nombre -->
      <div class="flex-1 min-w-0">
        <span class="text-xs text-gray-800 dark:text-gray-200 truncate block">{{ nodo.nombre }}</span>
      </div>

      <!-- Badges -->
      <span v-if="hijos.length || nodo.productos?.length" class="flex gap-0.5 flex-shrink-0">
        <span v-if="hijos.length" class="text-[10px] bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300 px-1 py-px rounded-full font-semibold leading-none">
          {{ hijos.length }}
        </span>
        <span v-if="nodo.productos?.length" class="text-[10px] bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300 px-1 py-px rounded-full font-semibold leading-none">
          📦{{ nodo.productos.length }}
        </span>
      </span>

      <!-- Acciones (visible en hover) -->
      <div class="flex gap-0 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0">
        <button @click="$emit('editar', nodo)" class="p-0.5 text-blue-500 hover:text-blue-700 dark:text-blue-400" title="Editar">
          <svg class="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>
        </button>
        <button @click="$emit('agregarSub', nodo)" class="p-0.5 text-green-500 hover:text-green-700 dark:text-green-400" title="Agregar subcategoría">
          <svg class="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>
        </button>
        <button @click="$emit('agregarProd', nodo)" class="p-0.5 text-orange-500 hover:text-orange-700 dark:text-orange-400" title="Agregar producto">
          <svg class="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/></svg>
        </button>
        <button @click="eliminarNodo" class="p-0.5 text-red-500 hover:text-red-700 dark:text-red-400" title="Eliminar">
          <svg class="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>
        </button>
      </div>
    </div>

    <!-- Hijos recursivos -->
    <ul v-if="expandido && hijos.length">
      <NodoCategoria
        v-for="hijo in hijos"
        :key="hijo.id"
        :nodo="hijo"
        :nivel="nivel + 1"
        @refresh="$emit('refresh')"
        @agregarSub="$emit('agregarSub', $event)"
        @agregarProd="$emit('agregarProd', $event)"
        @editar="$emit('editar', $event)"
        @quitarProd="$emit('quitarProd', $event)"
      />
    </ul>

    <!-- Productos (hojas) -->
    <ul v-if="expandido && nodo.productos?.length">
      <li
        v-for="prod in nodo.productos"
        :key="prod.id"
        class="flex items-center gap-1 px-1 py-0.5 rounded hover:bg-gray-100 dark:hover:bg-gray-700/50 group"
        :style="{ paddingLeft: `${((nivel + 1) * 12) + 4}px` }"
      >
        <span class="w-3 h-3 flex-shrink-0"></span>
        <span class="text-xs flex-shrink-0">📦</span>
        <span class="flex-1 text-xs text-gray-600 dark:text-gray-300 truncate">{{ prod.producto_id }} {{ prod.nombre }}</span>
        <span class="text-[10px] text-gray-400 dark:text-gray-500 flex-shrink-0">
          {{ prod.precio != null ? `$${Number(prod.precio).toFixed(2)}` : '' }}
        </span>
        <button
          @click="$emit('quitarProd', { categoria: nodo, producto: prod })"
          class="p-0.5 text-red-400 hover:text-red-600 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0"
          title="Quitar de categoría"
        >
          <svg class="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </li>
    </ul>
  </li>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useHttp } from '@/composables/useHttp.js'
import Swal from 'sweetalert2'

const props = defineProps({
  nodo: { type: Object, required: true },
  nivel: { type: Number, default: 0 },
})

const emit = defineEmits(['refresh', 'agregarSub', 'agregarProd', 'quitarProd', 'editar'])

const { del } = useHttp()

const expandido = ref(true)

// El backend serializa hijosRecursivos como "hijos_recursivos"
const hijos = computed(() => props.nodo.hijos_recursivos ?? props.nodo.hijos ?? [])
const tieneHijos = computed(() => hijos.value.length > 0 || (props.nodo.productos?.length ?? 0) > 0)

const eliminarNodo = async () => {
  const result = await Swal.fire({
    title: '¿Estás seguro?',
    text: `¿Deseas eliminar "${props.nodo.nombre}"? Los productos se desvinculan y las subcategorías quedan como raíz.`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sí, eliminar',
    cancelButtonText: 'Cancelar',
  })
  if (result.isConfirmed) {
    try {
      await del(`/pos2/categorias/${props.nodo.id}`)
      emit('refresh')
    } catch {
      Swal.fire('Error', 'No se pudo eliminar', 'error')
    }
  }
}
</script>
